import { defineComponent, createElementBlock, openBlock, createElementVNode, Fragment, renderList, createCommentVNode, createVNode, normalizeClass } from "vue";
import PSkeletonLoader from "../p-skeleton-loader.js";
const _hoisted_1 = { class: "block overflow-hidden rounded-xl border border-p-gray-30 bg-surface" };
const _hoisted_2 = { class: "mb-0 w-full bg-surface" };
const _hoisted_3 = { class: "relative border-b border-p-gray-30 px-4 py-2" };
const _hoisted_4 = {
  key: 0,
  class: "h-4 w-full border-b border-b-p-gray-20 bg-p-gray-10"
};
const _hoisted_5 = { class: "skeleton-fade" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "PTableLoader"
  },
  __name: "p-table-loader",
  props: {
    rows: {
      type: [Number, String],
      default: 4
    },
    columns: {
      type: [Number, String],
      default: 6
    },
    tdClasses: {
      type: String,
      default: "px-4 py-5"
    },
    tdSkeletonClasses: {
      type: String,
      default: "h-5"
    },
    withSubheader: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createElementVNode("table", _hoisted_2, [
          createElementVNode("thead", null, [
            createElementVNode("tr", null, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(Number(__props.columns), (col) => {
                return openBlock(), createElementBlock("th", {
                  key: col,
                  class: "bg-surface p-0"
                }, [
                  createElementVNode("div", _hoisted_3, [
                    createVNode(PSkeletonLoader, { class: "h-5" })
                  ]),
                  __props.withSubheader ? (openBlock(), createElementBlock("div", _hoisted_4)) : createCommentVNode("", true)
                ]);
              }), 128))
            ])
          ]),
          createElementVNode("tbody", _hoisted_5, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(Number(__props.rows), (i) => {
              return openBlock(), createElementBlock("tr", { key: i }, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(Number(__props.columns), (col) => {
                  return openBlock(), createElementBlock("td", {
                    key: col,
                    class: normalizeClass([__props.tdClasses, "border-b border-p-blue-15"])
                  }, [
                    createVNode(PSkeletonLoader, {
                      class: normalizeClass(__props.tdSkeletonClasses)
                    }, null, 8, ["class"])
                  ], 2);
                }), 128))
              ]);
            }), 128))
          ])
        ])
      ]);
    };
  }
});
export {
  _sfc_main as _
};
